export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Oil & Gas Educator — London, United Kingdom',
    'My students finally understand the difference between exploration, drilling, production, and refining. I used to waste hours searching for the right way to explain how the Oil & Gas industry actually works. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Energy Industry Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain well construction, reservoir pressure, safety protocols, or how to teach decision-making in Oil & Gas contexts. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Energy and Resources Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated Oil & Gas projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Oil & Gas Educator | London, United Kingdom',
    "The material on petroleum geology and reservoir formation completely changed how my students understand Oil & Gas. They finally grasp how oil and gas are found and why. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Energy Industry Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Energy Science Teacher | Berlin, Germany',
    "The 50 Oil & Gas projects transformed how my students see real-world applications. Now they investigate drilling methods, analyze environmental challenges, understand refining operations, and grasp why Oil & Gas knowledge matters professionally and globally. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The Oil & Gas terminology handbook gave me back my class time. I used to spend time explaining Oil & Gas concepts and misconceptions. Now I show the handbook and students instantly understand Oil & Gas concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Oil & Gas Industry Instructor | Copenhagen, Denmark',
    "The 100 case studies were eye-opening. My students finally understand why all this matters. They're analyzing real Oil & Gas challenges, evaluating safety concerns, exploring environmental solutions, and understanding how Oil & Gas fits in modern energy systems. This completely transformed how they see the Oil & Gas industry.",
  ],
];
